import { AgGridColumnDef, ClientWalletRolesMap, SortOption } from '@tassat/common-definitions';
import { AccountRecord } from '@tassat/fred-definitions';
import { UserAccountMapped } from '@tassat/fred-extended-definitions';

import AllWalletsPinnedCellRenderer from 'SharedComponents/cellRenderComponent/allWalletsPinnedCellRenderer';
import WalletInfoCellRenderer from 'SharedComponents/cellRenderComponent/walletInfoCellRenderer';

export type RowData = AccountRecord;

const didUserAccountUpdate = (userAccountA: UserAccountMapped, userAccountB: UserAccountMapped) => {
    if (!userAccountA) {
        return !userAccountB;
    } else {
        return userAccountA.account && userAccountA.userAccount &&
            userAccountB.account && userAccountB.userAccount &&
            userAccountA.account.AccountName === userAccountB.account.AccountName &&
            userAccountA.account.Account === userAccountB.account.Account &&
            // userAccountA.account.AvailableBalance === userAccountB.account.AvailableBalance &&
            userAccountA.account.IsLocked === userAccountB.account.IsLocked &&
            userAccountA.userAccount.IsFavorite === userAccountB.userAccount.IsFavorite &&
            userAccountA.userAccount.ClientRoleId === userAccountB.userAccount.ClientRoleId;
    }
};

export const columnDefs: AgGridColumnDef[] = [
    {
        field: 'WalletInfo',
        headerName: 'Account Info Loading',
        cellRendererSelector: (params) => {
            if (params.node.rowPinned) {
                return { component: AllWalletsPinnedCellRenderer };
            } else {
                return { component: WalletInfoCellRenderer };
            }
        },
        valueGetter: (params) => params.data,
        equals: didUserAccountUpdate,
        flex: 1
    },
    {
        field: 'account.AccountName',
        colId: 'account.AccountName',
        filter: 'agTextColumnFilter',
        hide: true,
        flex: 1
    },
    {
        field: 'account.Account',
        colId: 'account.Account',
        filter: 'agTextColumnFilter',
        hide: true,
        flex: 1
    },
    {
        field: 'account.IsLocked',
        colId: 'account.IsLocked',
        filter: 'agTextColumnFilter',
        hide: true,
        flex: 1
    },
    {
        field: 'account.IsPrimary',
        colId: 'account.IsPrimary',
        filter: 'agTextColumnFilter',
        hide: true,
        flex: 1
    },
    {
        field: 'account.IsLiquidityFacility',
        colId: 'account.IsLiquidityFacility',
        filter: 'agTextColumnFilter',
        hide: true,
        flex: 1
    },
    {
        field: 'userAccount.ClientRoleId',
        colId: 'userAccount.ClientRoleId',
        valueGetter: (params) => {
            const role = ClientWalletRolesMap.find((role) => role.id === params.data.userAccount.ClientRoleId);

            return role?.displayName || params.data.userAccount.ClientRoleId;
        },
        filter: 'agTextColumnFilter',
        hide: true,
        flex: 1
    },
    // {
    //     field: 'account.AvailableBalance',
    //     colId: 'account.AvailableBalance',
    //     filter: 'agTextColumnFilter',
    //     hide: true
    // },
    {
        field: 'userAccount.IsFavorite',
        colId: 'userAccount.IsFavorite',
        filter: 'agTextColumnFilter',
        hide: true,
        sort: 'desc',
        flex: 1
    }
];

export const walletSortOptions: SortOption[] = [
    {
        title: 'Account Name',
        colId: 'account.AccountName'
    },
    {
        title: 'Favorited',
        colId: 'userAccount.IsFavorite'
    },
    {
        title: 'Role',
        colId: 'userAccount.ClientRoleId'
    },
    // {
    //     title: 'Balance',
    //     colId: 'account.AvailableBalance'
    // },
    {
        title: 'Locked',
        colId: 'account.IsLocked'
    },
    {
        title: 'Primary',
        colId: 'account.IsPrimary'
    },
    {
        title: 'Liquidity Facility',
        colId: 'account.IsLiquidityFacility'
    },
    {
        title: 'Clear Sort',
        colId: 'clear'
    }
];